import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { faqs } from "@/config/business";
import { Reveal, Overline } from "@/components/Reveal";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-20 md:py-32 bg-cream" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <Overline>Questions</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight text-ink">
            Before You Visit
          </h2>
        </Reveal>

        <div className="mt-12 divide-y divide-primary/10 border-y border-primary/10">
          {faqs.map((f, i) => (
            <div key={f.q}>
              <button
                data-testid={`faq-question-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                aria-controls={`faq-answer-${i}`}
                className="w-full flex items-center justify-between gap-6 py-6 text-left min-h-[56px]"
              >
                <span className="font-display text-xl sm:text-2xl text-ink">{f.q}</span>
                <Plus
                  size={22}
                  aria-hidden="true"
                  className={`shrink-0 text-primary transition-transform duration-300 ${
                    open === i ? "rotate-45" : ""
                  }`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    id={`faq-answer-${i}`}
                    data-testid={`faq-answer-${i}`}
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 pr-10 text-sm sm:text-base leading-relaxed text-muted-foreground max-w-2xl">
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
